import { render, staticRenderFns } from "./BuildingClientPicker.vue?vue&type=template&id=a0da2be8&scoped=true"
import script from "./BuildingClientPicker.vue?vue&type=script&lang=js"
export * from "./BuildingClientPicker.vue?vue&type=script&lang=js"
import style0 from "./BuildingClientPicker.vue?vue&type=style&index=0&id=a0da2be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0da2be8",
  null
  
)

export default component.exports